export default function Contact() {
  return (
    <section id="contact" className="py-24 bg-slate-50">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-6">
            Entre em Contato
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed">
            Estamos prontos para discutir oportunidades de investimento e parcerias estratégicas
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          <div className="space-y-8">
            <div className="bg-white rounded-xl p-8 shadow-md">
              <div className="flex items-start space-x-4">
                <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-800 mb-3">Telefones</h3>
                  <a href="tel:+551141911617" className="block text-slate-600 hover:text-teal-600 transition-colors mb-2 cursor-pointer">
                    +55 (11) 4191-1617
                  </a>
                  <a href="tel:+5511963720003" className="block text-slate-600 hover:text-teal-600 transition-colors cursor-pointer">
                    +55 (11) 96372-0003
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-md">
              <div className="flex items-start space-x-4">
                <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-800 mb-3">Endereço</h3>
                  <p className="text-slate-600 leading-relaxed">
                    Al. Brasil, 584<br />
                    Alphaville – Barueri - SP<br />
                    Brasil
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-md">
              <div className="flex items-start space-x-4">
                <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-share-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-800 mb-4">Redes Sociais</h3>
                  <div className="flex space-x-3">
                    <a 
                      href="https://twitter.com" 
                      target="_blank" 
                      rel="nofollow noopener noreferrer"
                      className="w-10 h-10 bg-slate-100 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-all cursor-pointer group"
                    >
                      <i className="ri-twitter-x-line text-slate-600 group-hover:text-white text-lg"></i>
                    </a>
                    <a 
                      href="https://facebook.com" 
                      target="_blank" 
                      rel="nofollow noopener noreferrer"
                      className="w-10 h-10 bg-slate-100 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-all cursor-pointer group"
                    >
                      <i className="ri-facebook-fill text-slate-600 group-hover:text-white text-lg"></i>
                    </a>
                    <a 
                      href="https://linkedin.com" 
                      target="_blank" 
                      rel="nofollow noopener noreferrer"
                      className="w-10 h-10 bg-slate-100 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-all cursor-pointer group"
                    >
                      <i className="ri-linkedin-fill text-slate-600 group-hover:text-white text-lg"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-md overflow-hidden h-[500px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3658.0!2d-46.8556!3d-23.5!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDMwJzAwLjAiUyA0NsKwNTEnMjAuMiJX!5e0!3m2!1spt-BR!2sbr!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização Selem&Selem Participações"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
